import {openModalForSocialPostById} from '@Libraries/social-media-post.library';
import {isPlainObject} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import type {EntityCardProps} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import {EntityCardEntityType} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import {parseEntityCardProps} from '@Components/ai-chat-window/components/entity-card/entity-card.library';
import type {EntityCardAction} from './entity-card-action.types';

const SOCIAL_POST_CARD_ENDPOINT = 'socialmedia/getPostCard';

interface SocialPostEntityPayload {
  idPost: string;
}

const fetchSocialPostCard = async ({idPost}: SocialPostEntityPayload): Promise<EntityCardProps | null> => {
  if (idPost === '') {
    return null;
  }

  const response: unknown = await window.PMW.writeLocal(SOCIAL_POST_CARD_ENDPOINT, {idPost, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone});

  return isPlainObject(response) ? parseEntityCardProps(response) : null;
};

export const socialPostEntityCardAction: EntityCardAction<SocialPostEntityPayload> = {
  entityType: EntityCardEntityType.SOCIAL_POST,
  pointedAtIdOf: (payload): string => payload.idPost,
  parsePayload: (raw): SocialPostEntityPayload => ({idPost: typeof raw.idPost === 'string' ? raw.idPost : ''}),
  onClick: (payload): void => {
    if (payload.idPost === '') {
      return;
    }

    openModalForSocialPostById(payload.idPost);
  },
  fetchRefreshedCard: fetchSocialPostCard,
};
